import { useState, useEffect } from 'react';

type UseDataResult<T> = {
  data: T | null;
  error: Error | null;
  loading: boolean;
};

export default function useData<T>(url: string, parser = (a) => JSON.parse(a) as T, deps: any[] = []): UseDataResult<T> {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`${url} unavailable`);
        }

        const text = await response.text();
        const parsed = parser(text);

        setData(parsed);
      } catch (err) {
        setData(null);
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [url, ...deps]);

  return { data, error, loading };
}